/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

import {
    BarChart3,
    Activity,
    BrainCircuit,
    ShieldCheck
} from "lucide-react";

export default function AudienceBanner() {

    const stats = [

        {
            icon: BarChart3,
            value: "500+",
            label: "Stocks Tracked"
        },

        {
            icon: Activity,
            value: "50+",
            label: "Market Indicators"
        },

        {
            icon: BrainCircuit,
            value: "AI",
            label: "Research Engine"
        },

        {
            icon: ShieldCheck,
            value: "Real-Time",
            label: "Analytics"
        }
    ];

    return (

        <section className="mb-16">

            <div className="
                relative
                overflow-hidden
                rounded-3xl
                bg-gradient-to-r
                from-slate-900
                via-blue-950
                to-slate-900
                p-10
                shadow-2xl
            ">

                {/* Decorative Glow */}

                <div className="
                    absolute
                    top-0
                    left-0
                    w-72
                    h-72
                    bg-blue-500/20
                    blur-3xl
                    rounded-full
                "/>

                <div className="
                    absolute
                    bottom-0
                    right-0
                    w-72
                    h-72
                    bg-emerald-500/20
                    blur-3xl
                    rounded-full
                "/>

                <div className="relative z-10">

                    <div className="
                        text-center
                        mb-10
                    ">

                        <h2 className="
                            text-4xl
                            font-bold
                            text-white
                            mb-4
                        ">
                            Professional Analytics For Modern Investors
                        </h2>

                        <p className="
                            text-slate-300
                            text-lg
                            max-w-3xl
                            mx-auto
                        ">
                            Real-time market intelligence, portfolio analytics,
                            derivatives research and AI-powered insights —
                            all in a single platform.
                        </p>

                    </div>

                    <div className="
                        grid
                        grid-cols-2
                        lg:grid-cols-4
                        gap-6
                    ">

                        {stats.map((item, idx) => {

                            const Icon = item.icon;

                            return (

                                <div
                                    key={idx}
                                    className="
                                        bg-white/5
                                        backdrop-blur-sm
                                        border
                                        border-white/10
                                        rounded-2xl
                                        p-6
                                        text-center
                                    "
                                >

                                    <Icon
                                        size={30}
                                        className="
                                            text-blue-400
                                            mx-auto
                                            mb-4
                                        "
                                    />

                                    <div className="
                                        text-3xl
                                        font-bold
                                        text-white
                                    ">
                                        {item.value}
                                    </div>

                                    <div className="
                                        text-slate-300
                                        mt-2
                                    ">
                                        {item.label}
                                    </div>

                                </div>

                            );
                        })}

                    </div>

                </div>

            </div>

        </section>

    );
}